import { TJK_URL_SUFFIX } from 'Store/constants/horseRacing';

export default {
  [TJK_URL_SUFFIX.program.fullPage]: {
    title: 'At Yarışı Bülteni & Programı | Bilyoner',
    description: 'At yarışı bülteni ve programıyla kazanmaya bir adım daha yaklaş! Bahis yap, Bilyoner’in bülteninde günün koşularını ve at yarışı analizlerini keşfet!',
  },
  [TJK_URL_SUFFIX.fixedOdd.fullPage]: {
    title: 'Sabit İhtimalli At Yarışı Bülteni & Programı | Bilyoner',
    description:
      'Sabit ihtimallerle büyük kazançlara hazır olun! Günlük bültenimizdeki en iyi oranları, detaylı yarış analizlerini ve kazandıran tahminleri hemen keşfedin.',
  },
  [TJK_URL_SUFFIX.program.fullPage + '/adana' + TJK_URL_SUFFIX.program.urlSuffix]: {
    title: 'Adana At Yarışı Bülteni, Programı | Bilyoner',
    description: 'Adana hipodromundaki yarış bülteni ve programı Bilyoner’de! Adana hipodromu yarış bültenini, altılı bülteni ve tüm yarışları için tıklayın.',
  },
  [TJK_URL_SUFFIX.program.fullPage + '/istanbul' + TJK_URL_SUFFIX.program.urlSuffix]: {
    title: 'İstanbul At Yarışı Bülteni, Programı | Bilyoner',
    description: 'İstanbul hipodromundaki yarış bülteni ve programı Bilyoner’de! İstanbul hipodromu yarış bültenini, altılı bülteni ve tüm yarışları için tıklayın.',
  },
  [TJK_URL_SUFFIX.program.fullPage + '/izmir' + TJK_URL_SUFFIX.program.urlSuffix]: {
    title: 'İzmir At Yarışı Bülteni, Programı | Bilyoner',
    description: 'İzmir hipodromundaki yarış bülteni ve programı Bilyoner’de! İzmir hipodromu yarış bültenini, altılı bülteni ve tüm yarışları için tıklayın.',
  },
  [TJK_URL_SUFFIX.program.fullPage + '/bursa' + TJK_URL_SUFFIX.program.urlSuffix]: {
    title: 'Bursa At Yarışı Bülteni, Programı | Bilyoner',
    description: 'Bursa hipodromundaki yarış bülteni ve programı Bilyoner’de! Bursa hipodromu yarış bültenini, altılı bülteni ve tüm yarışları için tıklayın.',
  },
  [TJK_URL_SUFFIX.program.fullPage + '/ankara' + TJK_URL_SUFFIX.program.urlSuffix]: {
    title: 'Ankara At Yarışı Bülteni, Programı | Bilyoner',
    description: 'Ankara hipodromundaki yarış bülteni ve programı Bilyoner’de! Ankara hipodromu yarış bültenini, altılı bülteni ve tüm yarışları için tıklayın.',
  },
  [TJK_URL_SUFFIX.program.fullPage + '/sanliurfa' + TJK_URL_SUFFIX.program.urlSuffix]: {
    title: 'Şanlıurfa At Yarışı Bülteni, Programı | Bilyoner',
    description: 'Şanlıurfa hipodromundaki at yarışları Bilyoner’de! Şanlıurfa hipodromu yarış bültenini, altılı bülteni ve tüm yarışları için tıklayın.',
  },
  [TJK_URL_SUFFIX.program.fullPage + '/elazig' + TJK_URL_SUFFIX.program.urlSuffix]: {
    title: 'Elazığ At Yarışı Bülteni, Programı | Bilyoner',
    description: 'Elazığ hipodromundaki yarış bülteni ve programı Bilyoner’de! Elazığ hipodromu yarış bültenini, altılı bülteni ve tüm yarışları için tıklayın.',
  },
  [TJK_URL_SUFFIX.program.fullPage + '/diyarbakir' + TJK_URL_SUFFIX.program.urlSuffix]: {
    title: 'Diyarbakır At Yarışı Bülteni, Programı | Bilyoner',
    description: 'Diyarbakır hipodromundaki yarış bülteni ve programı Bilyoner’de! Diyarbakır hipodromu yarış bültenini, altılı bülteni ve tüm yarışları için tıklayın.',
  },
  [TJK_URL_SUFFIX.program.fullPage + '/kocaeli' + TJK_URL_SUFFIX.program.urlSuffix]: {
    title: 'Kocaeli At Yarışı Bülteni, Programı | Bilyoner',
    description: 'Kocaeli hipodromundaki yarış bülteni ve programı Bilyoner’de! Kocaeli hipodromu yarış bültenini, altılı bülteni ve tüm yarışları için tıklayın.',
  },
  [TJK_URL_SUFFIX.program.fullPage + '/antalya' + TJK_URL_SUFFIX.program.urlSuffix]: {
    title: 'Antalya At Yarışı Bülteni, Programı | Bilyoner',
    description: 'Antalya hipodromundaki yarış bülteni ve programı Bilyoner’de! Antalya hipodromu yarış bültenini, altılı bülteni ve tüm yarışları için tıklayın.',
  },
  [TJK_URL_SUFFIX.result.fullPage]: {
    title: 'At Yarışı Sonuçları & Kazananlar | Bilyoner',
    description: 'Günün en kazandıran kuponları ve at yarışı sonuçları Bilyoner’de! Tüm resmi sonuçları, istatistikleri ve analizleri görmek için hemen tıklayın.',
  },
  [TJK_URL_SUFFIX.result.fullPage + '/adana' + TJK_URL_SUFFIX.result.urlSuffix]: {
    title: 'Adana At Yarışı Sonuçları | Bilyoner',
    description: 'Adana hipodromu at yarışı sonuçları ve analizleri Bilyoner’de! Adana hipodromu tüm resmi sonuçları ve kazanan atları görmek için hemen tıklayın.',
  },
  [TJK_URL_SUFFIX.result.fullPage + '/istanbul' + TJK_URL_SUFFIX.result.urlSuffix]: {
    title: 'İstanbul At Yarışı Sonuçları | Bilyoner',
    description: 'İstanbul hipodromu at yarışı sonuçları ve analizleri Bilyoner’de! İstanbul hipodromu tüm resmi sonuçları ve kazanan atları görmek için hemen tıklayın.',
  },
  [TJK_URL_SUFFIX.result.fullPage + '/izmir' + TJK_URL_SUFFIX.result.urlSuffix]: {
    title: 'İzmir At Yarışı Sonuçları | Bilyoner',
    description: 'İzmir hipodromu at yarışı sonuçları ve analizleri Bilyoner’de! İzmir hipodromu tüm resmi sonuçları ve kazanan atları görmek için hemen tıklayın.',
  },
  [TJK_URL_SUFFIX.result.fullPage + '/bursa' + TJK_URL_SUFFIX.result.urlSuffix]: {
    title: 'Bursa At Yarışı Sonuçları | Bilyoner',
    description: 'Bursa hipodromu at yarışı sonuçları ve analizleri Bilyoner’de! Bursa hipodromu tüm resmi sonuçları ve kazanan atları görmek için hemen tıklayın.',
  },
  [TJK_URL_SUFFIX.result.fullPage + '/ankara' + TJK_URL_SUFFIX.result.urlSuffix]: {
    title: 'Ankara At Yarışı Sonuçları | Bilyoner',
    description: 'Ankara hipodromu at yarışı sonuçları ve analizleri Bilyoner’de! Ankara hipodromu tüm resmi sonuçları ve kazanan atları görmek için hemen tıklayın.',
  },
  [TJK_URL_SUFFIX.result.fullPage + '/sanliurfa' + TJK_URL_SUFFIX.result.urlSuffix]: {
    title: 'Şanlıurfa At Yarışı Sonuçları | Bilyoner',
    description: 'Şanlıurfa hipodromu at yarışı sonuçları ve analizleri Bilyoner’de! Şanlıurfa hipodromu tüm resmi sonuçları ve kazanan atları görmek için hemen tıklayın.',
  },
  [TJK_URL_SUFFIX.result.fullPage + '/elazig' + TJK_URL_SUFFIX.result.urlSuffix]: {
    title: 'Elazığ At Yarışı Sonuçları | Bilyoner',
    description: 'Elazığ hipodromu at yarışı sonuçları ve analizleri Bilyoner’de! Elazığ hipodromu tüm resmi sonuçları ve kazanan atları görmek için hemen tıklayın.',
  },
  [TJK_URL_SUFFIX.result.fullPage + '/diyarbakir' + TJK_URL_SUFFIX.result.urlSuffix]: {
    title: 'Diyarbakır At Yarışı Sonuçları | Bilyoner',
    description: 'Diyarbakır hipodromu at yarışı sonuçları ve analizleri Bilyoner’de! Diyarbakır hipodromu tüm resmi sonuçları ve kazanan atları görmek için hemen tıklayın.',
  },
  [TJK_URL_SUFFIX.result.fullPage + '/kocaeli' + TJK_URL_SUFFIX.result.urlSuffix]: {
    title: 'Kocaeli At Yarışı Sonuçları | Bilyoner',
    description: 'Kocaeli hipodromu at yarışı sonuçları ve analizleri Bilyoner’de! Kocaeli hipodromu tüm resmi sonuçları ve kazanan atları görmek için hemen tıklayın.',
  },
  [TJK_URL_SUFFIX.result.fullPage + '/antalya' + TJK_URL_SUFFIX.result.urlSuffix]: {
    title: 'Antalya At Yarışı Sonuçları | Bilyoner',
    description: 'Antalya hipodromu at yarışı sonuçları ve analizleri Bilyoner’de! Antalya hipodromu tüm resmi sonuçları ve kazanan atları görmek için hemen tıklayın.',
  },
  [TJK_URL_SUFFIX.agf.fullPage]: {
    title: 'AGF Tablosu | Bilyoner',
    description:
      'En güncel, anlık takip edebileceğiniz AGF tablosu Bilyoner’de! En çok oynanan altılı ganyan favorisi atları incelemek, detaylı istatistiki bilgi almak için tıklayın!',
  },
  [TJK_URL_SUFFIX.agf.fullPage + '/adana' + TJK_URL_SUFFIX.agf.urlSuffix]: {
    title: 'Adana AGF Tablosu | Bilyoner',
    description: 'En güncel Adana hipodromu AGF tablosu Bilyoner’de! Adana hipodromunda en çok oynanan altılı ganyan favorisi atları incelemek için tıklayın!'
  },
  [TJK_URL_SUFFIX.agf.fullPage + '/istanbul' + TJK_URL_SUFFIX.agf.urlSuffix]: {
    title: 'İstanbul AGF Tablosu | Bilyoner',
    description: 'En güncel İstanbul hipodromu AGF tablosu Bilyoner’de! İstanbul hipodromunda en çok oynanan altılı ganyan favorisi atları incelemek için tıklayın!'
  },
  [TJK_URL_SUFFIX.agf.fullPage + '/izmir' + TJK_URL_SUFFIX.agf.urlSuffix]: {
    title: 'İzmir AGF Tablosu | Bilyoner',
    description: 'En güncel İzmir hipodromu AGF tablosu Bilyoner’de! İzmir hipodromunda en çok oynanan altılı ganyan favorisi atları incelemek için tıklayın!'
  },
  [TJK_URL_SUFFIX.agf.fullPage + '/bursa' + TJK_URL_SUFFIX.agf.urlSuffix]: {
    title: 'Bursa AGF Tablosu | Bilyoner',
    description: 'En güncel Bursa hipodromu AGF tablosu Bilyoner’de! Bursa hipodromunda en çok oynanan altılı ganyan favorisi atları incelemek için tıklayın!'
  },
  [TJK_URL_SUFFIX.agf.fullPage + '/ankara' + TJK_URL_SUFFIX.agf.urlSuffix]: {
    title: 'Ankara AGF Tablosu | Bilyoner',
    description: 'En güncel Ankara hipodromu AGF tablosu Bilyoner’de! Ankara hipodromunda en çok oynanan altılı ganyan favorisi atları incelemek için tıklayın!'
  },
  [TJK_URL_SUFFIX.agf.fullPage + '/sanliurfa' + TJK_URL_SUFFIX.agf.urlSuffix]: {
    title: 'Şanlıurfa AGF Tablosu | Bilyoner',
    description: 'En güncel Şanlıurfa hipodromu AGF tablosu Bilyoner’de! Şanlıurfa hipodromunda en çok oynanan altılı ganyan favorisi atları incelemek için tıklayın!'
  },
  [TJK_URL_SUFFIX.agf.fullPage + '/elazig' + TJK_URL_SUFFIX.agf.urlSuffix]: {
    title: 'Elazığ AGF Tablosu | Bilyoner',
    description: 'En güncel Elazığ hipodromu AGF tablosu Bilyoner’de! Elazığ hipodromunda en çok oynanan altılı ganyan favorisi atları incelemek için tıklayın!'
  },
  [TJK_URL_SUFFIX.agf.fullPage + '/diyarbakir' + TJK_URL_SUFFIX.agf.urlSuffix]: {
    title: 'Diyarbakır AGF Tablosu | Bilyoner',
    description: 'En güncel Diyarbakır hipodromu AGF tablosu Bilyoner’de! Diyarbakır hipodromunda en çok oynanan altılı ganyan favorisi atları incelemek için tıklayın!'
  },
  [TJK_URL_SUFFIX.agf.fullPage + '/kocaeli' + TJK_URL_SUFFIX.agf.urlSuffix]: {
    title: 'Kocaeli AGF Tablosu | Bilyoner',
    description: 'En güncel Kocaeli hipodromu AGF tablosu Bilyoner’de! Kocaeli hipodromunda en çok oynanan altılı ganyan favorisi atları incelemek için tıklayın!'
  },
  [TJK_URL_SUFFIX.agf.fullPage + '/antalya' + TJK_URL_SUFFIX.agf.urlSuffix]: {
    title: 'Antalya AGF Tablosu | Bilyoner',
    description: 'En güncel Antalya hipodromu AGF tablosu Bilyoner’de! Antalya hipodromunda en çok oynanan altılı ganyan favorisi atları incelemek için tıklayın!'
  },
  [TJK_URL_SUFFIX.upcomingRaces.fullPage]: {
    title: 'Yaklaşan Koşular | Bilyoner',
    description:
      'Yaklaşan at yarışları güncel bilgilerle Bilyoner’de! Yaklaşan koşuları takip etmek, analiz ve istatistiki bilgilere ulaşmak için hemen tıklayın!',
  },
  [TJK_URL_SUFFIX.probables.fullPage]: {
    title: 'Muhtemeller, Muhtemel Ganyanlar | Bilyoner',
    description:
      'Hipodrom bazlı, günün muhtemel ganyanları Bilyoner’de! TJK muhtemelleri, koşacak atları, oranları anlık olarak takip etmek için hemen tıklayın!',
  },
  [TJK_URL_SUFFIX.author.fullPage]: {
    title: 'At Yarışı Yorumları, Tahminleri & Hazır Kuponlar | Bilyoner',
    description:
      'At Yarışı yorum ve tahminleri Bilyoner’de! Çok kazandıran hazır kuponlara, at yarışı detaylı yazar yorumlarına ve tüyolarına ulaşmak için hemen tıklayın!',
  },
  [TJK_URL_SUFFIX.author.fullPage + '/ercan-firtina']: {
    title: 'Ercan Fırtına At Yarışı Yorumları ve Tahminleri | Bilyoner',
    description: 'Ercan Fırtına at yarışı yorumları ve tahminleri Bilyoner’de! Ercan Fırtına hazırladığı kuponlara, detaylı yorumlara ve tüyolara ulaşmak için hemen tıklayın!'
  },
  [TJK_URL_SUFFIX.author.fullPage + '/kemal-demircan']: {
    title: 'Kemal Demircan At Yarışı Yorumları ve Tahminleri | Bilyoner',
    description: 'Kemal Demircan at yarışı yorumları ve tahminleri Bilyoner’de! Kemal Demircan hazırladığı kuponlara, detaylı yorumlara ve tüyolara ulaşmak için hemen tıklayın!'
  },
  [TJK_URL_SUFFIX.author.fullPage + '/esref-saati']: {
    title: 'Eşref Saati At Yarışı Yorumları ve Tahminleri | Bilyoner',
    description: 'Eşref Saati at yarışı yorumları ve tahminleri Bilyoner’de! Eşref Saati hazırladığı kuponlara, detaylı yorumlara ve tüyolara ulaşmak için hemen tıklayın!'
  },
  [TJK_URL_SUFFIX.author.fullPage + '/sahdun-kaya']: {
    title: 'Sahdun Kaya At Yarışı Yorumları ve Tahminleri | Bilyoner',
    description: 'Sahdun Kaya at yarışı yorumları ve tahminleri Bilyoner’de! Sahdun Kaya hazırladığı kuponlara, detaylı yorumlara ve tüyolara ulaşmak için hemen tıklayın!'
  },
  [TJK_URL_SUFFIX.author.fullPage + '/mustafa-sav']: {
    title: 'Mustafa Sav At Yarışı Yorumları ve Tahminleri | Bilyoner',
    description: 'Mustafa Sav at yarışı yorumları ve tahminleri Bilyoner’de! Mustafa Sav hazırladığı kuponlara, detaylı yorumlara ve tüyolara ulaşmak için hemen tıklayın!'
  },
  [TJK_URL_SUFFIX.author.fullPage + '/ediz-saglam']: {
    title: 'Ediz Sağlam At Yarışı Yorumları ve Tahminleri | Bilyoner',
    description: 'Ediz Sağlam at yarışı yorumları ve tahminleri Bilyoner’de! Ediz Sağlam hazırladığı kuponlara, detaylı yorumlara ve tüyolara ulaşmak için hemen tıklayın!'
  },
  [TJK_URL_SUFFIX.author.fullPage + '/gokhan-dedeoglu']: {
    title: 'Gökhan Dedeoğlu At Yarışı Yorumları ve Tahminleri | Bilyoner',
    description: 'Gökhan Dedeoğlu at yarışı yorumları ve tahminleri Bilyoner’de! Gökhan Dedeoğlu hazırladığı kuponlara, detaylı yorumlara ve tüyolara ulaşmak için hemen tıklayın!'
  },
  [TJK_URL_SUFFIX.author.fullPage + '/master-picks']: {
    title: 'Master Picks At Yarışı Yorumları ve Tahminleri | Bilyoner',
    description: 'Master Picks at yarışı yorumları ve tahminleri Bilyoner’de! Master Picks hazırladığı kuponlara, detaylı yorumlara ve tüyolara ulaşmak için hemen tıklayın!'
  },
  [TJK_URL_SUFFIX.author.fullPage + '/eray-koktay']: {
    title: 'Eray Koktay At Yarışı Yorumları ve Tahminleri | Bilyoner',
    description: 'Eray Koktay at yarışı yorumları ve tahminleri Bilyoner’de! Eray Koktay hazırladığı kuponlara, detaylı yorumlara ve tüyolara ulaşmak için hemen tıklayın!'
  },
  [TJK_URL_SUFFIX.author.fullPage + '/ferdi-akinci']: {
    title: 'Ferdi Akıncı At Yarışı Yorumları ve Tahminleri | Bilyoner',
    description: 'Ferdi Akıncı at yarışı yorumları ve tahminleri Bilyoner’de! Ferdi Akıncı hazırladığı kuponlara, detaylı yorumlara ve tüyolara ulaşmak için hemen tıklayın!'
  },
  [TJK_URL_SUFFIX.author.fullPage + '/berkay-kurt']: {
    title: 'Berkay Kurt At Yarışı Yorumları ve Tahminleri | Bilyoner',
    description: 'Berkay Kurt at yarışı yorumları ve tahminleri Bilyoner’de! Berkay Kurt hazırladığı kuponlara, detaylı yorumlara ve tüyolara ulaşmak için hemen tıklayın!'
  },
  [TJK_URL_SUFFIX.author.fullPage + '/fatih-varkal']: {
    title: 'Fatih Varkal At Yarışı Yorumları ve Tahminleri | Bilyoner',
    description: 'Fatih Varkal at yarışı yorumları ve tahminleri Bilyoner’de! Fatih Varkal hazırladığı kuponlara, detaylı yorumlara ve tüyolara ulaşmak için hemen tıklayın!'
  },
  [TJK_URL_SUFFIX.author.fullPage + '/alp-adiyaman']: {
    title: 'Alp Adıyaman (Renk) At Yarışı Yorumları ve Tahminleri | Bilyoner',
    description: 'Alparslan Adıyaman at yarışı yorumları ve tahminleri Bilyoner’de! Alp Adıyaman (Renk) hazırladığı kuponlara, detaylı yorumlara ve tüyolara ulaşmak için hemen tıklayın!'
  },
  [TJK_URL_SUFFIX.coupons.fullPage]: {
    title: 'At Yarışı Kuponlarım | Bilyoner',
    description: 'Bilyoner’de oluşturduğunuz at yarışı kuponlarınızı görüntüleyin ve yönetin. Kuponlarım sayfası ile geçmiş ve aktif kuponlarınızı kolayca takip edin.',
    meta: [{ name: 'robots', content: 'noindex' }],
  },
  [TJK_URL_SUFFIX.shareCoupons.fullPage]: {
    title: 'Kupon Paylaş | Bilyoner',
    description: 'Bilyoner’de oluşturduğunuz at yarışı kuponlarını arkadaşlarınızla kolayca paylaşın. Bahis heyecanını başkalarıyla paylaşarak daha fazla kazanma fırsatı yaratın.',
    meta: [{ name: 'robots', content: 'noindex' }]
  },
  [TJK_URL_SUFFIX.horseCard.fullPage]: {
    title: 'At Detay | Bilyoner',
    description: 'Bilyoner’de atların tüm bilgilerini inceleyin! At detay sayfasında performans geçmişi, koşu istatistikleri ve daha fazlasını keşfedin.',
    meta: [{ name: 'robots', content: 'noindex' }]
  },
  [TJK_URL_SUFFIX.runDetailWidget.fullPage]: {
    title: 'Yarış Detay | Bilyoner',
    description: 'Bilyoner yarış detayları sayfasında, yarışın tüm istatistiklerini, yarış sonuçlarını ve önemli bilgileri keşfedin.',
    meta: [{ name: 'robots', content: 'noindex' }]
  },
  [TJK_URL_SUFFIX.tjkTv.fullPage]: {
    title: 'TJK TV Canlı İzle | Bilyoner',
    description: 'TJK TV’yi Bilyoner’de canlı izleyin. Yarışları canlı olarak takip edebilir, at yarışı heyecanına dahil olabilirsiniz.',
  },
  [TJK_URL_SUFFIX.tjkTvExternal.fullPage]: {
    title: 'TJK TV Yurtdışı Canlı İzle | Bilyoner',
    description: 'TJK TV Yurtdışı’nı Bilyoner’de canlı izleyin. Yurt dışı yarışlarını canlı olarak takip edebilir, at yarışı heyecanına dahil olabilirsiniz.',
  },
};
